(function() {
    'use strict';
    angular
        .module('vobeApp')
        .factory('PublicSiteLanguages', PublicSiteLanguages);

    PublicSiteLanguages.$inject = ['$resource'];

    function PublicSiteLanguages ($resource) {
        var resourceUrl =  'api/public-site-language-relationships?siteName=vobe';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();
